/**
 * Re-export shim — the implementation moved to `@heidi/auth/contracts`
 * (OpenSpec `monorepo-auth-package` · S1). Name-intact for `getAccessToken.ts`,
 * which stays app-side (it imports `@/store` and is class B on the Rematch
 * handoff list).
 */
export { IS_DUAL_RUN_ACTIVE } from '@heidi/auth/contracts';
